import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../../assets/images/logo.png';
import { useSidebar } from '../../../context/SidebarContext';
import FeatherIcon from 'feather-icons-react';

const SidebarLogo = () => {
  const { toggleSidebar } = useSidebar();

  return (
    <div className="navbar-brand-box d-flex justify-content-between align-items-center px-3">
      {/* Dark Logo */}
      <Link to="/" className="logo logo-dark d-flex align-items-center">
        <span className="logo-sm">
          <img src={logo} alt="Logo Small" height="40" />
        </span>
        <span className="logo-lg">
          <img src={logo} alt="Logo Dark" height="80" />
        </span>
      </Link>
      <button
        type="button"
        className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
        id="vertical-hover"
        onClick={toggleSidebar}
      >
        <FeatherIcon icon="circle" />
      </button>
    </div>
  );
};

export default SidebarLogo;
